import { DigitalData } from "@/src/types/digitalData";
import { PUBLISHER } from "@/src/utils/digitalData/constants";
import {
  getContentCharge,
  getEnvironment,
  getInitialLocale,
  getLanguageCode,
  getSysEnv,
  getViewport
} from "@/src/utils/digitalData/environment";
import {
  sanitizePathname,
  sanitizeTitle
} from "@/src/utils/digitalData/sanitization";

/**
 * Creates the initial digitalData object for analytics.
 * Used by both sync bootstrap and useDigitalDataInit.
 */
export const initializeDigitalData = (locale?: string): DigitalData => {
  const environment = getEnvironment();
  const pathname = sanitizePathname(globalThis.location.pathname);
  const initialLocale = locale || getInitialLocale();
  const languageCode = getLanguageCode(initialLocale);

  return {
    pageInstanceID: "",
    version: {
      almaVersion: "2.3",
      specificationVersion: "1.0"
    },
    page: {
      pageInfo: {
        pageID: "",
        sysEnv: getSysEnv(),
        pageTitle: sanitizeTitle(document.title || ""),
        language: languageCode,
        publisher: PUBLISHER,
        locationProtocol: globalThis.location.protocol.slice(0, -1),
        locationHost: globalThis.location.host,
        locationPathName: pathname
      },
      category: {
        primaryCategory: "",
        pageType: "otherpage"
      },
      attributes: {
        environment,
        viewport: getViewport(globalThis.innerWidth),
        width: globalThis.innerWidth,
        userAgentHeader: navigator.userAgent,
        contentCharge: getContentCharge()
      }
    },
    user: [
      {
        segment: {
          loginstatus: "loggedout"
        }
      }
    ]
  };
};
